<template lang="pug">
.t-content
  section.info-sec
    .max-container
      .reset-wrapper
        img.animate__animated.animate__wobble.animate__repeat-3(src="/images/logo.png")
        h2.text-center {{ $t('ui.reset_password') }}
        form
          .mb-3
            //- label.col-form-label {{ $t('ui.phone_number') }}:
            input.form-control#accountname(type="text" :placeholder="$t('ui.phone_number')" v-model.trim.lazy="$v.accountId.$model" @keyup.enter="updatePassword")
            .error.w-100(v-if="$v.accountId.$dirty && !$v.accountId.required")
              small.text-danger.form-text {{ $tc('message.list.phoneRequired') }}
            .error.w-100(v-else-if="$v.accountId.$dirty && !$v.accountId.minLength")
              small.text-danger.form-text {{ $tc('message.min_length') }}
          .text-center
            button.btn-submit(type='button' @click.prevent="updatePassword") {{$t('ui.send')}}
        //- .input-group.mb-3
            .verification.p-3.mb-4
              .text-capitalize.text-center.mb-3.text-verify {{ $t("ui.last_4_digits") }}
              .d-flex.justify-content-between
                .input-group.w-25.mx-1
                  input.form-control.text-center.number(id="validate1" type="text" pattern="\d*" maxlength="1" v-model="numberOne" @input="focus($event, 2)" @keyup.enter="updatePassword")
                .input-group.w-25.mx-1
                  input.form-control.text-center.number(id="validate2" type="text" pattern="\d*" maxlength="1" v-model="numberTwo" @input="focus($event, 3)" @keyup.enter="updatePassword")
                .input-group.w-25.mx-1
                  input.form-control.text-center.number(id="validate3" type="text" pattern="\d*" maxlength="1" v-model="numberThree" @input="focus($event, 4)" @keyup.enter="updatePassword")
                .input-group.w-25.mx-1
                  input.form-control.text-center.number(id="validate4" type="text" pattern="\d*" maxlength="1" v-model="numberFour" @keyup.enter="updatePassword")
              .error.w-100.px-2.mb-3(v-if="$v.numberOne.$dirty && (!$v.numberFour.required || !$v.numberThree.required || !$v.numberTwo.required || !$v.numberOne.required)")
                small.text-danger.form-text {{$tc('ui.phone_no_reminder')}}
              .text-center.px-lg-5.mt-2 {{$t('ui.reset_tips')}}
  //- #modal-forgot-password.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-dialog-centered
      .modal-content
        .modal-header-cus
          img(src='assets/img/logo.png')
          h2 {{ $t('ui.forgot_password') }}
        .modal-body
          form
            .mb-3
              input.form-control#accountname(type="text" :placeholder="$t('ui.phone_number')" v-model.trim.lazy="$v.accountId.$model" @keyup.enter="updatePassword")
              .error.w-100(v-if="$v.accountId.$dirty && !$v.accountId.required")
                small.text-danger.form-text {{ $tc('message.list.phoneRequired') }}
              .error.w-100(v-else-if="$v.accountId.$dirty && !$v.accountId.minLength")
                small.text-danger.form-text {{ $tc('message.min_length') }}
            //- .input-group.mb-3
              .verification.p-3.mb-4
                .text-capitalize.text-center.mb-3.text-verify {{ $t("ui.last_4_digits") }}
                .d-flex.justify-content-between
                  .input-group.w-25.mx-1
                    input.form-control.text-center.number(id="validate1" type="text" pattern="\d*" maxlength="1" v-model="numberOne" @input="focus($event, 2)" @keyup.enter="updatePassword")
                  .input-group.w-25.mx-1
                    input.form-control.text-center.number(id="validate2" type="text" pattern="\d*" maxlength="1" v-model="numberTwo" @input="focus($event, 3)" @keyup.enter="updatePassword")
                  .input-group.w-25.mx-1
                    input.form-control.text-center.number(id="validate3" type="text" pattern="\d*" maxlength="1" v-model="numberThree" @input="focus($event, 4)" @keyup.enter="updatePassword")
                  .input-group.w-25.mx-1
                    input.form-control.text-center.number(id="validate4" type="text" pattern="\d*" maxlength="1" v-model="numberFour" @keyup.enter="updatePassword")
                .error.w-100.px-2.mb-3(v-if="$v.numberOne.$dirty && (!$v.numberFour.required || !$v.numberThree.required || !$v.numberTwo.required || !$v.numberOne.required)")
                  small.text-danger.form-text {{$tc('ui.phone_no_reminder')}}
                .text-center.px-lg-5.mt-2 {{$t('ui.reset_tips')}}
            .error.w-100.text-center.mb-2(v-if="!feedback.success")
              small.text-danger.form-text {{ feedback.status }}
        .modal-footer.s2
          .text-center
            button.btn-submit(type='button' @click.stop="updatePassword") {{$t('ui.send')}}
</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      accountId: "",
      feedback: {
        success: true,
        status: ""
      },
      // numberOne: "",
      // numberTwo: "",
      // numberThree: "",
      // numberFour: ""
    };
  },
  validations: {
    accountId: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    // numberOne: {
    //   required
    // },
    // numberTwo: {
    //   required
    // },
    // numberThree: {
    //   required
    // },
    // numberFour: {
    //   required
    // }
  },
  computed: {
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  watch:{
    sessionToken(newState, oldState){
      var vm = this
      if(newState !== ''){
        vm.$router.push("/").catch(err => {});
      }
    }
  },
  mounted() {
    let vm = this
    $("#modal-forgot-password").on("shown.bs.modal", function() {
      $("#accountname").trigger('focus')
    });

    $("#modal-forgot-password").on("hidden.bs.modal", function() {
      vm.reset()
    });

    $("input.number").on("keypress", function(e) {
      var isNumber = /^[0-9]$/i.test(e.key)
      if (!isNumber) e.preventDefault()
    });
    window.scroll(0,0)
  },
  methods: {
    focus(e, i) {
      if (e.data) $(`#validate${i}`).focus();
    },
    updatePassword: function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let account_id = this.accountId
        // let verification_code = this.numberOne + this.numberTwo + this.numberThree + this.numberFour
        this.loading = true
        this.$store
          .dispatch("user/forgotPassword", { account_id })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {
              this.reset()
              this.$helpers.showDialog(
                this.$t("ui.success"),
                this.$t("message.forgot_password_success"),
                "success",
                this
              );
            } else {
              var vm = this;
              var sites = ['mseric1', 'mseric2', 'epicvip', 'epicinfinity', 'epicwin2']
              if(sites.includes(response.status)){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  confirmButtonText: "Proceed",
                  text: vm.$tc("message.wrong_site.description") + vm.$tc("message.wrong_site." + response.status) + ". Click 'Proceed' button will redirect you to the site",
                  type: "info"
                }).then(result => {
                  window.location.href = vm.$tc("message.url."+ response.status)
                });
              }else{
                if(response.status){
                  this.feedback.status = this.$tc('message.list.' + response.status) 
                }
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
                }               
              }
              // this.feedback.status = this.$t("error." + response.status)
              // this.$helpers.showDialog(
              //   this.$t("ui.attention"),
              //   this.$t("message.list." + response.status),
              //   "info",
              //   this
              // );
            }
          })
          .catch(response => {
            this.loading = false
            // this.feedback.success = false
            // this.$helpers.showDialog(
            //   this.$t("ui.attention"),
            //   this.$t("message.list." + response.status),
            //   "info",
            //   this
            // );
            // this.feedback.status = this.$t("error." + response.status)
            this.feedback.success = response.success
            var vm = this;
            var sites = ['mseric1', 'mseric2', 'epicvip', 'epicinfinity', 'epicwin2']
            if(sites.includes(response.status)){
              this.feedback.status = this.$tc("message.wrong_site.description") + this.$tc("message.wrong_site." + response.status)
              this.$swal({
                title: vm.$tc("ui.attention"),
                confirmButtonText: "Proceed",
                text: vm.$tc("message.wrong_site.description") + vm.$tc("message.wrong_site." + response.status) + ". Click 'Proceed' button will redirect you to the site",
                type: "info"
              }).then(result => {
                window.location.href = vm.$tc("message.url."+ response.status)
              });
            }else{
              if(response.status){
                this.feedback.status = this.$tc('message.list.' + response.status) 
              }              
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }
          });
      }
    },
    reset(){
      this.accountId = ""
      // this.numberOne = ""
      // this.numberTwo = ""
      // this.numberThree = ""
      // this.numberFour = ""
      this.$v.$reset()
      $("#modal-forgot-password").modal("hide");
    }
  }
};
</script>
